/* eslint-disable no-console */
import * as yup from 'yup';

import React, { Fragment, useEffect, useState } from 'react';
import { addUserGiftCard, getGiftCardDetails } from 'ReduxStore/gift/Action';
import { conditions, radioButtonItems } from 'Utils/options';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import BottomIcon from '../../Assets/img/svg/GiftCards/BottomIcon.svg';
import BottomStar from '../../Assets/img/svg/GiftCards/BottomStar.svg';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import CustomCheckBox from 'Components/CheckBox/CustomCheckBox';
import CustomModal from 'Components/Modals/CustomModal';
import CustomRadio from 'Components/Reusable/Buttons/CustomRadio';
import GiftLogo from '../../Assets/img/svg/GiftCards/GiftCard.svg';
import GiftSmall from '../../Assets/img/svg/GiftCards/GiftCardSmall.svg';
import NotFound from '../../Assets/img/svg/giftCard/NotFound.svg';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { RootState } from '../../ReduxStore/store';
import { Routes } from 'Utils';
import Selector from 'Components/Selector/Selector';
import Used from '../../Assets/img/svg/giftCard/Used.svg';
import { getGiftCardWelcomeText } from './helpers';
import { registerParent } from '../../ReduxStore/user';
import { useFormik } from 'formik';
import { useStyles } from './GiftCard.styles';
import GiftCardText from './GiftCardText';
import newText from './GiftCardText';
import { useMediaQuery } from '@material-ui/core';

interface State {
	fullName: string;
	email: string;
	password: string;
	childFullName: string;
	dateOfBirth: string;
	shipping_address: string;
	shipping_state: string;
	shipping_city: string;
	showPassword: boolean;
	shipping_zipCode: string;
	shipping_phoneNumber: string;
	billing_address: string;
	billing_state: string;
	billing_city: string;
	billing_zipCode: string;
	billing_phoneNumber: string;
}

interface ParamsI {
	activationCode: string;
}

const GiftCards = () => {
	const classes = useStyles();
	const history = useHistory();
	const matches = useMediaQuery('(max-width:440px)');
	const [checked, setChecked] = useState(false);
	const [loading, setLoading] = useState(true);
	const [checkShippingTerms, setCheckShippingTerms] = useState(false);
	const [gender, setGender] = useState('');
	const [gestation, setGestation] = useState('');
	const dispatch = useDispatch();

	const { activationCode } = useParams<ParamsI>();

	useEffect(() => {
		// setLoading(true)
		dispatch(getGiftCardDetails(activationCode));
	}, []);

	const giftCardDetails: any = useSelector((state: RootState) => state.gifts['giftCard']);

	const giftCardError = useSelector((state: RootState) => state.gifts['errors']);
	const isRegistered = useSelector((state: RootState) => state.gifts['isUserRegistered']);

	if (isRegistered) {
		history.push(Routes.EmailSent);
	}

	const validationSchema = yup.object({
		email: yup.string().email('Enter a valid email').required('Email is required'),
		password: yup
			.string()
			.min(8, 'Password needs to be 8 or more characters')
			.required('Password is required'),
		fullName: yup.string().required('Required'),
		childFullName: yup.string().required('Required'),
		shipping_address: yup.string().required('Required'),
		shipping_state: yup.string().required('Required'),
		shipping_city: yup.string().required('Required'),
		shipping_zipCode: yup.string().required('Required'),
		shipping_phoneNumber: yup.string().required('Required'),
		billing_address: checked ? yup.string().required('Required') : yup.string(),
		billing_state: checked ? yup.string().required('Required') : yup.string(),
		billing_city: checked ? yup.string().required('Required') : yup.string(),
		billing_zipCode: checked ? yup.string().required('Required') : yup.string(),
		billing_phoneNumber: checked ? yup.string().required('Required') : yup.string(),
	});

	const [values, setValues] = useState<State>({
		fullName: '',
		email: '',
		password: '',
		childFullName: '',
		dateOfBirth: '',
		showPassword: false,
		shipping_address: '',
		shipping_state: '',
		shipping_city: '',
		shipping_zipCode: '',
		shipping_phoneNumber: '',
		billing_address: '',
		billing_state: '',
		billing_city: '',
		billing_zipCode: '',
		billing_phoneNumber: '',
		// isSameAddress:false
	});

	const errors: any = useSelector((state: RootState) => state.users['errors']);
	const isRegistred: any = useSelector((state: RootState) => state.users['isRegistered']);

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(event.target.checked);
	};

	const handleChangeShippingCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckShippingTerms(event.target.checked);
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};
	const loginElements = [
		{
			id: 1,
			name: 'fullName',
			type: 'text',
			fvalue: 'fullName',
			label: 'Full Name',
			placeholder: '',
		},
		{
			id: 2,
			name: 'email',
			label: 'Email',
			type: 'email',
			fvalue: 'email',
			placeholder: '',
		},
		{
			id: 3,
			name: 'password',
			label: 'Password',
			type: 'password',
			fvalue: 'password',
			placeholder: '',
		},
	];
	const kidsElements = [
		{
			id: 1,
			name: 'childFullName',
			type: 'text',
			fvalue: 'childFullName',
			label: 'Name',
			placeholder: '',
		},
		{
			id: 2,
			name: 'dateOfBirth',
			type: 'date',
			fvalue: 'dateOfBirth',
			label: 'Birth Date',
			placeholder: '',
		},
	];

	const ShippingElements = [
		{
			id: 1,
			name: 'shipping_address',
			type: 'text',
			fvalue: 'shipping_address',
			label: 'Address',
			placeholder: '',
		},
		{
			id: 2,
			name: 'shipping_city',
			type: 'text',
			fvalue: 'shipping_city',
			label: 'City',
			placeholder: '',
		},
		{
			id: 3,
			name: 'shipping_state',
			type: 'text',
			fvalue: 'shipping_state',
			label: 'State',
			placeholder: '',
		},
		{
			id: 4,
			name: 'shipping_zipCode',
			type: 'text',
			fvalue: 'shipping_zipCode',
			label: 'Zip Code',
			placeholder: '',
		},
		{
			id: 5,
			name: 'shipping_phoneNumber',
			type: 'text',
			fvalue: 'shipping_phoneNumber',
			label: 'Phone Number',
			placeholder: '',
		},
	];

	const BillingElements = [
		{
			id: 1,
			name: 'billing_address',
			type: 'text',
			fvalue: 'billing_address',
			label: 'Address',
			placeholder: '',
		},
		{
			id: 2,
			name: 'billing_city',
			type: 'text',
			fvalue: 'billing_city',
			label: 'City',
			placeholder: '',
		},
		{
			id: 3,
			name: 'billing_state',
			type: 'text',
			fvalue: 'billing_state',
			label: 'State',
			placeholder: '',
		},
		{
			id: 4,
			name: 'billing_zipCode',
			type: 'text',
			fvalue: 'billing_zipCode',
			label: 'Zip Code',
			placeholder: '',
		},
		{
			id: 5,
			name: 'billing_phoneNumber',
			type: 'text',
			fvalue: 'billing_phoneNumber',
			label: 'Phone Number',
			placeholder: '',
		},
	];

	const formik = useFormik({
		initialValues: {
			fullName: '',
			email: '',
			password: '',
			childFullName: '',
			dateOfBirth: '',
			billing_address: '',
			billing_city: '',
			billing_state: '',
			billing_zipCode: '',
			billing_phoneNumber: '',
			shipping_address: '',
			shipping_state: '',
			shipping_city: '',
			shipping_zipCode: '',
			shipping_phoneNumber: '',
			isSameAddress: false,
		},
		validationSchema: validationSchema,

		onSubmit: values => {
			if (giftCardDetails.id) {
				setLoading(false);
				dispatch(
					addUserGiftCard(
						values.fullName,
						values.email,
						values.password,
						values.childFullName,
						values.dateOfBirth,
						gender,
						gestation,
						values.billing_address,
						values.billing_city,
						values.billing_state,
						values.billing_zipCode,
						values.billing_phoneNumber,
						values.shipping_address,
						values.shipping_city,
						values.shipping_state,
						values.shipping_zipCode,
						values.shipping_phoneNumber,
						giftCardDetails?.id,
						checked,
					),
				);
			}
		},
	});
	const list = [
		{ id: 1, name: 'Preterm' },
		{ id: 2, name: 'Term' },
	];
	const handleModalClick = (condition: string) => {
		condition === 'yes'
			? window.open('https://www.fledglingsflight.com/gift-membership', '_self')
			: history.push('/');
	};

	const handleUserExists = () => {
		return window.location.reload();
	};

	const goToLogin = () => history.push('/');

	const alreadyUsedCondition = [
		{
			id: 1,
			name: 'LOGIN NOW',
		},
	];

	const userExistsCondition = [
		{
			id: 1,
			name: 'OK',
		},
	];
	console.log(giftCardError);

	const getConditions = (errorStatus: string) => {
		if (errorStatus == 'This code has already been activated. Click the button below to login.') {
			return alreadyUsedCondition;
		} else if (errorStatus == 'A user with that email already exists') {
			return userExistsCondition;
		} else {
			return conditions;
		}
	};
	const getOnClickHandler = (errorStatus: string) => {
		if (errorStatus == 'This code has already been activated. Click the button below to login.') {
			return handleModalClick;
		} else if (errorStatus == 'A user with that email already exists') {
			return handleUserExists;
		} else {
			return goToLogin;
		}
	};
	return (
		<Fragment>
			<div>
				<CustomModal open={giftCardError ? true : false}>
					<ConditionalCard
						image={
							giftCardError != 'This code has already been activated. Click the button below to login.'
								? NotFound
								: Used
						}
						information={giftCardError && giftCardError}
						conditions={getConditions(giftCardError)}
						onClick={getOnClickHandler(giftCardError)}
					/>
				</CustomModal>
				<div className={`${classes.gift} my-lg-5 my-md-3 my-2`}>
					<img src={GiftLogo} alt="Gift icon" />
				</div>
				<div className={`${classes.smallGift} my-3`}>
					<img src={GiftSmall} alt="Gift icon" className={classes.smallGiftIcon} />
				</div>
				<h2 className={`${classes.title} text-center my-md-5 my-2 px-5`}>Someone must love you very much!</h2>
				<div className={`${classes.textContainer} px-3 text-center`}>
					{/* <h1>{getGiftCardWelcomeText(giftCardDetails?.validityPeriod, giftCardDetails?.subscriptionLevel)}</h1> */}
					{giftCardDetails ? newText(giftCardDetails) : ''}

					{/* <h1>{giftCardDetails && getGiftCardWelcomeText(giftCardDetails.subscriptionLevel,giftCardDetails.validityPeriod)}</h1> */}
					<p className="my-3 my-md-4">
						Complete the form below to get started. Once you have completed the form, you will receive an
						email to activate your account. Make sure that you check your Junk/Spam and Promotional folders
						for the email. When you login, you will have access to all of the developmental nutrients to help
						your child thrive.
					</p>
					<p>Let’s begin.</p>
				</div>
				<div className={`${classes.bottomIconWrapper} px-5`}>
					<img src={BottomIcon} alt="Gift icon" className={classes.bottomIcon} />
				</div>
				<div className={`${classes.background} px-3 py-4 mx-auto my-1`}>
					{errors && errors.message != null ? (
						<div className="d-flex justify-content-center pt-3 alert alert-danger">
							<span className={classes.error}>{errors.message}</span>
						</div>
					) : (
						''
					)}
					<form onSubmit={formik.handleSubmit}>
						<ul className={`${classes.listItems} mb-4`}>
							<h6 className={`${classes.text} text-center py-2`}>Your Details</h6>
							{loginElements.map(element => (
								<li key={element.id} className="mt-2">
									<ReusableInput
										name={element.name}
										type={element.type}
										placeholder={element.placeholder}
										formik={formik}
										fvalue={element.fvalue}
										label={element.label}
										width={matches ? '240.17px' : '383.79px'}
										height="53.91px"
										required={true}
									/>
								</li>
							))}
							<h6 className={`${classes.text} text-center py-2 my-2 bold`}>{"Child's Details"}</h6>
							{kidsElements.map(element => (
								<li key={element.id} className="mt-2">
									<ReusableInput
										name={element.name}
										type={element.type}
										fvalue={element.fvalue}
										placeholder={element.placeholder}
										label={element.label}
										formik={formik}
										width={matches ? '240.17px' : '383.79px'}
										height="53.91px"
										required={true}
									/>
								</li>
							))}
							<div className="d-flex flex-column flex-wrap mx-auto mt-4 mb-3 justify-content-center align-items-center">
								<section className="mb-3">
									<Selector itemList={list} gestation={setGestation} />
								</section>
								<CustomRadio items={radioButtonItems} genderChoice={setGender} componentWidth />
							</div>
							<h6 className={`${classes.text} text-center my-4`}>{'Shipping Details'}</h6>
							{ShippingElements.map(element => (
								<li key={element.id} className="mt-2">
									<ReusableInput
										name={element.name}
										type={element.type}
										fvalue={element.fvalue}
										placeholder={element.placeholder}
										label={element.label}
										formik={formik}
										width={matches ? '240.17px' : '383.79px'}
										height="53.91px"
									/>
								</li>
							))}
							<div className="d-flex px-md-3 px-lg-3 flex-column">
								<CustomCheckBox
									checked={checked}
									mainText="Shipping and billing address are different"
									handleChangeCheckbox={handleChangeCheckbox}
								/>
							</div>
							{checked && (
								<>
									<h6 className={`${classes.text} text-center my-2`}>{'Billing Details'}</h6>
									{BillingElements.map(element => (
										<li key={element.id} className="mt-2">
											<ReusableInput
												name={element.name}
												type={element.type}
												fvalue={element.fvalue}
												placeholder={element.placeholder}
												label={element.label}
												formik={formik}
												width={matches ? '240.17px' : '383.79px'}
												height="53.91px"
											/>
										</li>
									))}
								</>
							)}
							<div className="d-flex  flex-column">
								<div className="px-md-3 px-lg-3">
									<CustomCheckBox
										checked={checkShippingTerms}
										mainText="I read and agree to the"
										subText=" Terms & Conditions"
										handleChangeCheckbox={handleChangeShippingCheckbox}
									/>
								</div>
								<CommonButton
									disabled={checkShippingTerms ? false : true}
									common={{
										// width: '381.87px',
										width: matches ? '241px' : '381.87px',
										height: '48px',
										background: '#7FD6DD',
										radius: '200px',
										color: 'white',
										// height: '48px',
										// background: '#7FD6DD',
										// radius: '200px',
										// fontWeight: 'lighter',
										// fontSize: '24px',
									}}
									command={
										loading ? 'CREATE ACCOUNT' : <ClipLoader color={'white'} loading={true} size={30} />
									}
								/>
							</div>
						</ul>
					</form>
				</div>
			</div>
		</Fragment>
	);
};

export default GiftCards;
